export default __webpack_public_path__ + "static/media/in-dani-i-trust.b2c7df88.jpeg";